import { badge } from './badge';
import { button } from './button';
import { footer } from './footer';
import { gallery } from './gallery';
import { gridTeaser } from './gridTeaser';
import { maps } from './maps';
import { modal } from './modal';
import { subtitle } from './subtitle';
import { title } from './title';

const components = {
  badge: { ...badge },
  button: { ...button },
  footer: { ...footer },
  gallery: { ...gallery },
  gridTeaser: { ...gridTeaser },
  maps: { ...maps },
  modal: { ...modal },
  subtitle: { ...subtitle },
  title: { ...title }
};

export default components;
